import * as React from 'react';
import styled from 'styled-components';

import { NoResult, TemplatesEmptyState } from 'ui/illustrations';
import { Link } from 'ui/links';
import { colors, spacing } from 'ui/theme';
import { body1, heading4 } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';

const EmptyStateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${pxToRem(400)};
`;

const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${pxToRem(461)};
`;

const Title = styled.div`
  margin-bottom: ${spacing.half};
  ${heading4};
`;

const Caption = styled.div`
  text-align: center;
  ${body1};
  color: ${colors.textSecondary};
`;

type ImageProps = {
  height?: number;
  width?: number;
};
interface EmptyStateGeneratorProps {
  Image: React.ComponentType<React.PropsWithChildren<ImageProps>>;
  title: string;
  id: string;
  children: React.ReactNode;
}

export const EmptyStateGenerator = ({ Image, title, id, children }: EmptyStateGeneratorProps) => (
  <EmptyStateWrapper data-test={id}>
    <EmptyStateContent>
      <Image data-test="empty-state-image" />
      <Title>{title}</Title>
      <Caption data-test="empty-state-caption">{children}</Caption>
    </EmptyStateContent>
  </EmptyStateWrapper>
);

export const GeneralEmptyState = (): JSX.Element => (
  <EmptyStateGenerator
    Image={TemplatesEmptyState}
    title="No templates yet"
    id="template-index-empty-state"
  >
    <div>
      Learn more by visiting our{' '}
      <Link size="body1" target="_blank" href={'https://support.iterable.com/'}>
        Knowledge Center
      </Link>
      .
    </div>
  </EmptyStateGenerator>
);

export const NoResults = (): JSX.Element => (
  <EmptyStateGenerator Image={NoResult} title="No matching results" id="template-index-no-results">
    {'Try adjusting your filters or searching by different keywords.'}
  </EmptyStateGenerator>
);
